import { BankAccountCreatePage } from '@/features/bank-account/pages/BankAccountCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bank-account/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bank_account.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BankAccountCreatePage,
});
